var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommerce(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.6666 23.3333H26.3333M29.6666 6.66663H26.3333M9.66659 6.66663H6.33325M9.66659 23.3333H6.33325M7.99992 28.3333H27.9999C31.6818 28.3333 34.6666 25.3485 34.6666 21.6666V8.33329C34.6666 4.65139 31.6818 1.66663 27.9999 1.66663H7.99992C4.31802 1.66663 1.33325 4.65139 1.33325 8.33329V21.6666C1.33325 25.3485 4.31802 28.3333 7.99992 28.3333ZM21.3333 15C21.3333 16.8409 19.8409 18.3333 17.9999 18.3333C16.159 18.3333 14.6666 16.8409 14.6666 15C14.6666 13.159 16.159 11.6666 17.9999 11.6666C19.8409 11.6666 21.3333 13.159 21.3333 15Z",
    stroke: "#25A249",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommerce);
export default __webpack_public_path__ + "static/media/commerce.9e3949e47751a96543d89e6da218dc77.svg";
export { ForwardRef as ReactComponent };